import { render, staticRenderFns } from "./ProductionOverview.vue?vue&type=template&id=1b1ad7ee&scoped=true&"
import script from "./ProductionOverview.vue?vue&type=script&lang=js&"
export * from "./ProductionOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOverview.vue?vue&type=style&index=0&id=1b1ad7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ad7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VTooltip})
